import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { disabledMixin } from '../disabledMixin';
import { iconOffsetMixin } from '../iconOffsetMixin';
import { spaceMixin } from '../spaceMixin';
import { typographyMixin } from '../typographyMixin';

/** @class MenuItemMixin */
/**
 * Standalone styles for a menu action item.
 *
 * @example
 * import { MenuItemMixin, IconHeart } from "@zillow/constellation";
 *
 * const Component = styled.button`
 *     ${MenuItemMixin}
 * `;
 *
 * <Component><IconHeart /> Menu item</Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */

var anchorCSS = function anchorCSS(props) {
  var as = props.as,
    href = props.href;
  if (as === 'a' || !!href) {
    return token({
      anchorFontColor: 'MenuItem.anchor.color.hover',
      defaultFontColor: 'MenuItem.fontColor',
      anchorTextDecoration: 'MenuItem.anchor.textDecoration.hover'
    }, function (_ref) {
      var anchorFontColor = _ref.anchorFontColor,
        defaultFontColor = _ref.defaultFontColor,
        anchorTextDecoration = _ref.anchorTextDecoration;
      return css(["text-decoration:none;&&:hover,&&:active{text-decoration:", ";color:", ";}&:visited{color:", ";}"], anchorTextDecoration, anchorFontColor, defaultFontColor);
    })(props);
  }
  return token({
    fontColor: 'MenuItem.fontColor',
    textDecoration: 'MenuItem.textDecoration.hover'
  }, function (_ref2) {
    var fontColor = _ref2.fontColor,
      textDecoration = _ref2.textDecoration;
    return css(["text-decoration:none;&&:hover,&&:active,&&:visited{text-decoration:", ";color:", ";}"], textDecoration, fontColor);
  })(props);
};
export var MenuItemMixin = function MenuItemMixin(props) {
  return token({
    backgroundColor: 'MenuItem.backgroundColor',
    backgroundColorHover: 'MenuItem.backgroundColorHover',
    backgroundColorActive: 'MenuItem.backgroundColorActive',
    border: 'MenuItem.border',
    fontColor: 'MenuItem.fontColor',
    fontType: 'MenuItem.fontType',
    iconSize: 'MenuItem.Icon.size',
    iconColor: 'MenuItem.Icon.color',
    iconMarginRight: 'MenuItem.Icon.marginRight',
    horizontalSpacing: 'MenuItem.horizontalSpacing',
    verticalSpacing: 'MenuItem.verticalSpacing',
    textAlign: 'MenuItem.textAlign'
  }, function (_ref3) {
    var backgroundColor = _ref3.backgroundColor,
      backgroundColorHover = _ref3.backgroundColorHover,
      backgroundColorActive = _ref3.backgroundColorActive,
      _ref3$border = _ref3.border,
      border = _ref3$border === void 0 ? 0 : _ref3$border,
      fontColor = _ref3.fontColor,
      fontType = _ref3.fontType,
      iconSize = _ref3.iconSize,
      iconColor = _ref3.iconColor,
      iconMarginRight = _ref3.iconMarginRight,
      horizontalSpacing = _ref3.horizontalSpacing,
      verticalSpacing = _ref3.verticalSpacing,
      _ref3$textAlign = _ref3.textAlign,
      textAlign = _ref3$textAlign === void 0 ? 'left' : _ref3$textAlign;
    return css(["", " ", " align-items:center;background-color:", ";border:", ";box-sizing:border-box;color:", ";cursor:pointer;display:flex;outline:none;padding:", "px ", "px;text-align:", ";width:100%;transition:background-color 200ms ease;&:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit;}&:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;}&::-moz-focus-inner{border:0;}", " &:focus:not(:disabled):not([aria-disabled]),&:hover:not(:disabled):not([aria-disabled]){background-color:", ";}&:active:not(:disabled):not([aria-disabled]){background-color:", ";}", " &[aria-disabled]{", " pointer-events:none;}> ", "{color:", ";flex-shrink:0;margin-right:", ";}"], typographyMixin(Object.assign({
      fontType: fontType,
      fontTypeIconAlignment: false
    }, props)), iconOffsetMixin(Object.assign({}, props, {
      iconSize: iconSize
    })), backgroundColor, border, fontColor, verticalSpacing, horizontalSpacing, textAlign, anchorCSS(props), backgroundColorHover, backgroundColorActive, disabledMixin(props), disabledMixin(Object.assign({}, props, {
      disabled: true
    })), StyledIcon, iconColor, iconMarginRight ? iconMarginRight + "px" : spaceMixin('xs')(props));
  })(props);
};